import { useCallback, useState, useEffect } from "react";

const CustomPaginator = ({
    currentPage,
    totalPages,
    handlePageChange
}) => {
    const [pagesToShow, setPagesToShow] = useState([]);
    const maxPageNumbers = 5;

    const calculatePageRange = useCallback((totalPagesInt) => {
        let startPageInt = 0;
        let endPageInt = 1;

        if (totalPagesInt <= maxPageNumbers) {
            startPageInt = 1;
            endPageInt = totalPagesInt;
        } else {
            const half = Math.floor(maxPageNumbers / 2);
            
            if (currentPage <= half) {
                startPageInt = 1;
                endPageInt = maxPageNumbers;
            } else if (currentPage + half >= totalPagesInt) {
                startPageInt = totalPagesInt - maxPageNumbers + 1;
                endPageInt = totalPagesInt;
            } else {
                startPageInt = currentPage - half;
                endPageInt = currentPage + half;
            }
        }

        const lengthArray = endPageInt - startPageInt + 1;
        setPagesToShow(Array.from({ length: lengthArray }, (_, index) => startPageInt + index));
    }, [currentPage]);

    useEffect(() => {
        calculatePageRange(totalPages);
    }, [totalPages, currentPage, calculatePageRange]); // No se incluye calculatePageRange aquí

    
    return (
        <div className="flex justify-center items-center mt-2">
            <div className="flex items-center">
                <ul className="flex space-x-1 ml-2">
                    {(currentPage > 1) && <li className="flex items-center justify-center cursor-pointer text-gray-50 text-base w-8 h-8 bg-gray-800 hover:bg-gray-700 rounded shadow-lg"
                                        onClick={() => handlePageChange(currentPage - 1)}>
                                        <span className="material-icons">keyboard_arrow_left</span>
                                        </li>
                    }
                    {pagesToShow.map((pageNumber) => (
                            <li
                                key={pageNumber}
                                className={`flex items-center justify-center cursor-pointer text-base w-8 h-8 
                                            border border-gray-100 rounded hover:bg-gray-200 shadow-lg ${
                                currentPage === pageNumber
                                        ? 'bg-primary text-white hover:bg-green-800'
                                        : 'text-black dark:text-white hover:bg-gray-200'
                                }`}
                                onClick={() => handlePageChange(pageNumber)}
                            >
                                {pageNumber}
                            </li>
                    ))}
                    {(currentPage < totalPages) && <li className="flex items-center justify-center cursor-pointer text-gray-50 text-base w-8 h-8 bg-gray-800 hover:bg-gray-700 rounded shadow-lg"
                                            onClick={() => handlePageChange(currentPage + 1)}>
                                            <span className="material-icons">keyboard_arrow_right</span>
                                        </li>
                    }
                </ul>
            </div>
        </div>
    );
}
export default CustomPaginator;